import {createRouter, createWebHashHistory} from 'vue-router';
import {useUserStore} from "@/stores/UserStore";

const routes = [
    {
        path: '/',
        name: 'home',
        exact: true,
        component: () => import('./components/authentication/Login.vue')
    },
    {
        path: '/login',
        name: 'login',
        exact: true,
        component: () => import('./components/authentication/Login.vue')
    },
    {
        path: '/forgotPassword',
        name: 'forgotPassword',
        exact: true,
        component: () => import('./components/authentication/ForgotPassword.vue')
    },
    {
        path: '/forgotPasswordSubmission',
        name: 'forgotPasswordSubmission',
        exact: true,
        component: () => import('./components/authentication/ForgotPasswordSubmission.vue')
    },
    {
        path: '/register',
        name: 'register',
        exact: true,
        component: () => import('./components/authentication/Register.vue')
    },
    {
        path: '/pricing',
        name: 'pricing',
        exact: true,
        component: () => import('./components/authentication/Pricing.vue')
    },
    {
        path: '/error',
        name: 'error',
        exact: true,
        component: () => import('./components/authentication/Error.vue')
    },
    {
        path: '/commonProfile',
        name: 'commonProfile',
        exact: true,
        component: () => import('./components/common/Profile.vue')
    },
    {
        path: '/commonProfileAdmin',
        name: 'commonProfileAdmin',
        exact: true,
        component: () => import('./components/common/ProfileAdmin.vue')
    },
    {
        path: '/commonNotifications',
        name: 'commonNotifications',
        exact: true,
        component: () => import('./components/common/Notifications.vue')
    },
    {
        path: '/commonProfilePassword',
        name: 'commonProfilePassword',
        exact: true,
        component: () => import('./components/common/ProfilePassword.vue')
    },
    {
        path: '/commonProfileAccount',
        name: 'commonProfileAccount',
        exact: true,
        component: () => import('./components/common/ProfileAccount.vue')
    },
    {
        path: '/commonProfileAccountUpgradeCancelled',
        name: 'commonProfileAccountUpgradeCancelled',
        exact: true,
        component: () => import('./components/common/ProfileAccountUpgradeCancelled.vue')
    },
    {
        path: '/commonProfileAccountUpgradeSuccessful',
        name: 'commonProfileAccountUpgradeSuccessful',
        exact: true,
        component: () => import('./components/common/ProfileAccountUpgradeSuccessful.vue')
    },
    {
        path: '/commonProfileTerms',
        name: 'commonProfileTerms',
        exact: true,
        component: () => import('./components/common/ProfileTerms.vue')
    },
    {
        path: '/commonProfilePrivacy',
        name: 'commonProfilePrivacy',
        exact: true,
        component: () => import('./components/common/ProfilePrivacy.vue')
    },
    {
        path: '/commonApplicationStore',
        name: 'commonApplicationStore',
        exact: true,
        component: () => import('./components/common/ProfileApplicationStore.vue')
    },
    {
        path: '/commonApplication001',
        name: 'commonApplication001',
        exact: true,
        component: () => import('./components/common/ProfileApplication001.vue')
    },
    {
        path: '/commonApplication002',
        name: 'commonApplication002',
        exact: true,
        component: () => import('./components/common/ProfileApplication002.vue')
    },
    {
        path: '/commonOverviewAuditTrail',
        name: 'commonOverviewAuditTrail',
        exact: true,
        component: () => import('./components/common/AuditTrail.vue')
    },
    {
        path: '/commonOverviewTasks',
        name: 'commonOverviewTasks',
        exact: true,
        component: () => import('./components/common/Tasks.vue')
    },
    {
        path: '/commonProspects',
        name: 'commonProspects',
        exact: true,
        component: () => import('./components/common/Prospects.vue')
    },
    {
        path: '/commonOverviewProcesses',
        name: 'commonOverviewProcesses',
        exact: true,
        component: () => import('./components/common/Processes.vue')
    },
    {
        path: '/commonAppointments',
        name: 'commonAppointments',
        exact: true,
        component: () => import('./components/common/Appointments.vue')
    },
    {
        path: '/commonReminders',
        name: 'commonReminders',
        exact: true,
        component: () => import('./components/common/Reminders.vue')
    },
    {
        path: '/commonInvoiceFollowups',
        name: 'commonInvoiceFollowups',
        exact: true,
        component: () => import('./components/common/InvoiceFollowups.vue')
    },
    {
        path: '/commonClaimFollowups',
        name: 'commonClaimFollowups',
        exact: true,
        component: () => import('./components/common/ClaimFollowups.vue')
    },
    {
        path: '/commonPhoneCalls',
        name: 'commonPhoneCalls',
        exact: true,
        component: () => import('./components/common/PhoneCalls.vue')
    },
    {
        path: '/commonProducts',
        name: 'commonProducts',
        exact: true,
        component: () => import('./components/common/Products.vue')
    },
    {
        path: '/commonSuppliers',
        name: 'commonSuppliers',
        exact: true,
        component: () => import('./components/common/Suppliers.vue')
    },
    {
        path: '/commonConfigurationBasic',
        name: 'commonConfigurationBasic',
        exact: true,
        component: () => import('./components/common/ConfigurationBasic.vue')
    },
    {
        path: '/commonConfigurationBusiness',
        name: 'commonConfigurationBusiness',
        exact: true,
        component: () => import('./components/common/ConfigurationBusiness.vue')
    },
    {
        path: '/commonConfigurationTeam',
        name: 'commonConfigurationTeam',
        exact: true,
        component: () => import('./components/common/ConfigurationTeam.vue')
    },
    {
        path: '/commonConfigurationBankAccounts',
        name: 'commonConfigurationBankAccounts',
        exact: true,
        component: () => import('./components/common/ConfigurationBankAccounts.vue')
    },
    {
        path: '/commonConfigurationEmail',
        name: 'commonConfigurationEmail',
        exact: true,
        component: () => import('./components/common/ConfigurationEmail.vue')
    },
    {
        path: '/commonConfigurationTemplates',
        name: 'commonConfigurationTemplates',
        exact: true,
        component: () => import('./components/common/ConfigurationTemplates.vue')
    },
    {
        path: '/commonConfigurationForms',
        name: 'commonConfigurationForms',
        exact: true,
        component: () => import('./components/common/ConfigurationForms.vue')
    },
    {
        path: '/commonConfigurationLocations',
        name: 'commonConfigurationLocations',
        exact: true,
        component: () => import('./components/common/ConfigurationLocations.vue')
    },
    {
        path: '/commonConfigurationBilling',
        name: 'commonConfigurationBilling',
        exact: true,
        component: () => import('./components/common/ConfigurationBilling.vue')
    },
    {
        path: '/commonConfigurationNoteTemplates',
        name: 'commonConfigurationNoteTemplates',
        exact: true,
        component: () => import('./components/common/ConfigurationNoteTemplates.vue')
    },
    {
        path: '/commonConfigurationProvisions',
        name: 'commonConfigurationProvisions',
        exact: true,
        component: () => import('./components/common/ConfigurationProvisions.vue')
    },
    {
        path: '/commonConfigurationAvailability',
        name: 'commonConfigurationAvailability',
        exact: true,
        component: () => import('./components/common/ConfigurationAvailability.vue')
    },
    {
        path: '/commonConfigurationLabels',
        name: 'commonConfigurationLabels',
        exact: true,
        component: () => import('./components/common/ConfigurationLabels.vue')
    },
    {
        path: '/commonClients',
        name: 'commonClients',
        exact: true,
        component: () => import('./components/common/Clients.vue'),
        props: route => ({
            inputClientId: route.query.inputClientId,
            inputActiveTab: route.query.inputActiveTab,
        })
    },
    {
        path: '/commonClientDetail',
        name: 'commonClientDetail',
        exact: true,
        component: () => import('./components/common/ClientDetail.vue'),
        props: route => ({
            inputClientId: route.query.inputClientId,
            inputActiveTab: route.query.inputActiveTab,
        })
    },
    {
        path: '/commonFinancialInvoices',
        name: 'commonFinancialInvoices',
        exact: true,
        component: () => import('./components/common/Invoices.vue'),
        props: route => ({
            inputAppointmentId: route.query.inputAppointmentId,
            inputInvoiceId: route.query.inputInvoiceId
        })
    },
    {
        path: '/commonFinancialPayments',
        name: 'commonFinancialPayments',
        exact: true,
        component: () => import('./components/common/Payments.vue')
    },
    {
        path: '/commonOnlinePayments',
        name: 'commonOnlinePayments',
        exact: true,
        component: () => import('./components/common/OnlinePayments.vue')
    },
    {
        path: '/commonFinancialBillingRuns',
        name: 'commonFinancialBillingRuns',
        exact: true,
        component: () => import('./components/common/BillingRuns.vue')
    },
    {
        path: '/commonFinancialUnpaidRuns',
        name: 'commonFinancialUnpaidRuns',
        exact: true,
        component: () => import('./components/common/UnpaidRuns.vue')
    },
    {
        path: '/commonFinancialManagement',
        name: 'commonFinancialManagement',
        exact: true,
        component: () => import('./components/common/FinancialManagement.vue')
    },
    {
        path: '/businessApplications',
        name: 'businessApplications',
        exact: true,
        component: () => import('./components/business/Applications.vue')
    },
    {
        path: '/healthOverviewPlanning',
        name: 'healthOverviewPlanning',
        exact: true,
        component: () => import('./components/health/Planning.vue')
    },
    {
        path: '/healthOverviewQualification',
        name: 'healthOverviewQualification',
        exact: true,
        component: () => import('./components/health/Qualification.vue')
    },
    {
        path: '/commonCalendar',
        name: 'commonCalendar',
        exact: true,
        component: () => import('./components/common/Calendar.vue')
    },
    {
        path: '/commonSearch',
        name: 'commonSearch',
        exact: true,
        component: () => import('./components/common/Search.vue')
    },
    {
        path: '/commonOverviewReports',
        name: 'commonOverviewReports',
        exact: true,
        component: () => import('./components/common/OverviewReports.vue')
    },
    {
        path: '/commonOverviewFiles',
        name: 'commonOverviewFiles',
        exact: true,
        component: () => import('./components/common/OverviewFiles.vue')
    },
    {
        path: '/commonOverviewDashboard',
        name: 'commonOverviewDashboard',
        exact: true,
        component: () => import('./components/common/OverviewDashboard.vue')
    },
    {
        path: '/commonHelp',
        name: 'commonHelp',
        exact: true,
        component: () => import('./components/common/Help.vue')
    },
    {
        path: '/usermanualIntroduction',
        name: 'usermanualIntroduction',
        exact: true,
        component: () => import('./components/usermanual/Introduction.vue')
    },
    {
        path: '/usermanualChapter1',
        name: 'usermanualChapter1',
        exact: true,
        component: () => import('./components/usermanual/Chapter1.vue')
    },
    {
        path: '/usermanualChapter2',
        name: 'usermanualChapter2',
        exact: true,
        component: () => import('./components/usermanual/Chapter2.vue')
    },
    {
        path: '/commonFeature',
        name: 'commonFeature',
        exact: true,
        component: () => import('./components/common/Feature.vue')
    },
    {
        path: '/commonSurvey',
        name: 'commonSurvey',
        exact: true,
        component: () => import('./components/common/Survey.vue')
    },
    {
        path: '/commonDigitalForms',
        name: 'commonDigitalForms',
        exact: true,
        component: () => import('./components/common/DigitalForms.vue')
    },
    {
        path: '/commonAdminOverview',
        name: 'commonAdminOverview',
        exact: true,
        component: () => import('./components/common/AdminOverview.vue')
    },
    {
        path: '/commonEmailCampaigns',
        name: 'commonEmailCampaigns',
        exact: true,
        component: () => import('./components/common/EmailCampaigns.vue')
    },
    {
        path: '/commonClientSegments',
        name: 'commonClientSegments',
        exact: true,
        component: () => import('./components/common/ClientSegments.vue')
    },
    {
        path: '/healthApplications',
        name: 'healthApplications',
        exact: true,
        component: () => import('./components/health/Applications.vue')
    },
    {
        path: '/healthConfigurationPractitioners',
        name: 'healthConfigurationPractitioners',
        exact: true,
        component: () => import('./components/health/ConfigurationPractitioners.vue')
    },
    {
        path: '/healthFinancialClaims',
        name: 'healthFinancialClaims',
        exact: true,
        component: () => import('./components/health/Claims.vue')
    },
    {
        path: '/pmOverviewHome',
        name: 'pmOverviewHome',
        exact: true,
        component: () => import('./components/pmmodule/OverviewHome.vue')
    },
    {
        path: '/msOverviewHome',
        name: 'msOverviewHome',
        exact: true,
        component: () => import('./components/msmodule/OverviewHome.vue')
    },
    {
        path: '/healthOverviewHome',
        name: 'healthOverviewHome',
        exact: true,
        component: () => import('./components/health/OverviewHome.vue')
    },
    {
        path: '/faOverviewHome',
        name: 'faOverviewHome',
        exact: true,
        component: () => import('./components/famodule/OverviewHome.vue')
    },
    {
        path: '/sbOverviewHome',
        name: 'sbOverviewHome',
        exact: true,
        component: () => import('./components/sbmodule/OverviewHome.vue')
    },
    {
        path: '/cpOverviewHome',
        name: 'cpOverviewHome',
        exact: true,
        component: () => import('./components/clientportal/OverviewHome.vue')
    },
    {
        path: '/gbpPayment',
        name: 'gbpPayment',
        exact: true,
        component: () => import('./components/common/GbpPayment.vue')
    },
    {
        path: '/gbpPaymentSuccess',
        name: 'gbpPaymentSuccess',
        exact: true,
        component: () => import('./components/common/GbpPaymentSuccess.vue')
    },
    {
        path: '/gbpPaymentError',
        name: 'gbpPaymentError',
        exact: true,
        component: () => import('./components/common/GbpPaymentError.vue')
    },
    {
        path: '/usdPayment',
        name: 'usdPayment',
        exact: true,
        component: () => import('./components/common/UsdPayment.vue')
    },
    {
        path: '/usdPaymentSuccess',
        name: 'usdPaymentSuccess',
        exact: true,
        component: () => import('./components/common/UsdPaymentSuccess.vue')
    },
    {
        path: '/usdPaymentError',
        name: 'usdPaymentError',
        exact: true,
        component: () => import('./components/common/UsdPaymentError.vue')
    },
    {
        path: '/zarPayment',
        name: 'zarPayment',
        exact: true,
        component: () => import('./components/common/ZarPayment.vue')
    },
    {
        path: '/zarPaymentSuccess',
        name: 'zarPaymentSuccess',
        exact: true,
        component: () => import('./components/common/ZarPaymentSuccess.vue')
    },
    {
        path: '/zarPaymentError',
        name: 'zarPaymentError',
        exact: true,
        component: () => import('./components/common/ZarPaymentError.vue')
    },
    {
        path: '/zarPaymentCancel',
        name: 'zarPaymentCancel',
        exact: true,
        component: () => import('./components/common/ZarPaymentCancel.vue')
    },
    {
        path: '/siOverview',
        name: 'siOverview',
        exact: true,
        component: () => import('./components/simodule/Overview.vue')
    },
    {
        path: '/siPlan',
        name: 'siPlan',
        exact: true,
        component: () => import('./components/simodule/Plan.vue')
    },
    {
        path: '/siTrack',
        name: 'siTrack',
        exact: true,
        component: () => import('./components/simodule/Track.vue')
    },
    {
        path: '/siAchieve',
        name: 'siAchieve',
        exact: true,
        component: () => import('./components/simodule/Achieve.vue')
    },
    {
        path: '/siAdmin',
        name: 'siAdmin',
        exact: true,
        component: () => import('./components/simodule/Admin.vue')
    },
    {
        path: '/siApplications',
        name: 'siApplications',
        exact: true,
        component: () => import('./components/simodule/Applications.vue')
    },
    {
        path: '/siPricingLegacy',
        name: 'siPricingLegacy',
        exact: true,
        component: () => import('./components/simodule/Pricing.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siPricing',
        name: 'siPricing',
        exact: true,
        component: () => import('./components/simodule/PricingStripe.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siPricingSuccessful',
        name: 'siPricingSuccessful',
        exact: true,
        component: () => import('./components/simodule/PricingSuccessful.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siPricingCancelled',
        name: 'siPricingCancelled',
        exact: true,
        component: () => import('./components/simodule/PricingCancelled.vue'),
        props: route => ({
            affiliateId: route.query.affiliateId
        })
    },
    {
        path: '/siAffiliate',
        name: 'siAffiliate',
        exact: true,
        component: () => import('./components/simodule/Affiliate.vue')
    },
    {
        path: '/siAffiliateClients',
        name: 'siAffiliateClients',
        exact: true,
        component: () => import('./components/simodule/AffiliateClients.vue')
    },
    {
        path: '/siAffiliateInvoices',
        name: 'siAffiliateInvoices',
        exact: true,
        component: () => import('./components/simodule/AffiliateInvoices.vue')
    },
    {
        path: '/siAffiliateConfiguration',
        name: 'siAffiliateConfiguration',
        exact: true,
        component: () => import('./components/simodule/AffiliateConfiguration.vue')
    },
    {
        path: '/siAffiliateConfigurationPassword',
        name: 'siAffiliateConfigurationPassword',
        exact: true,
        component: () => import('./components/simodule/AffiliateConfigurationPassword.vue')
    },
    {
        path: '/siProfile',
        name: 'siProfile',
        exact: true,
        component: () => import('./components/simodule/Profile.vue')
    },
    {
        path: '/siNotifications',
        name: 'siNotifications',
        exact: true,
        component: () => import('./components/simodule/Notifications.vue')
    },
    {
        path: '/commonProfileSiAdmin',
        name: 'commonProfileSiAdmin',
        exact: true,
        component: () => import('./components/common/ProfileSiAdmin.vue')
    },
    {
        path: '/siLogin',
        name: 'siLogin',
        exact: true,
        component: () => import('./components/simodule/Login.vue')
    },
    {
        path: '/siConfiguration',
        name: 'siConfiguration',
        exact: true,
        component: () => import('./components/simodule/Configuration.vue')
    },
    {
        path: '/siConfigurationUpgrade',
        name: 'siConfigurationUpgrade',
        exact: true,
        component: () => import('./components/simodule/ConfigurationUpgrade.vue')
    },
    {
        path: '/siConfigurationUpgradeCancelled',
        name: 'siConfigurationUpgradeCancelled',
        exact: true,
        component: () => import('./components/simodule/ConfigurationUpgradeCancelled.vue')
    },
    {
        path: '/siConfigurationUpgradeSuccessful',
        name: 'siConfigurationUpgradeSuccessful',
        exact: true,
        component: () => import('./components/simodule/ConfigurationUpgradeSuccessful.vue')
    },
    {
        path: '/siConfigurationPassword',
        name: 'siConfigurationPassword',
        exact: true,
        component: () => import('./components/simodule/ConfigurationPassword.vue')
    },
    {
        path: '/siConfigurationAlerts',
        name: 'siConfigurationAlerts',
        exact: true,
        component: () => import('./components/simodule/ConfigurationAlerts.vue')
    },
    {
        path: '/siConfigurationEmailLists',
        name: 'siConfigurationEmailLists',
        exact: true,
        component: () => import('./components/simodule/ConfigurationEmailLists.vue')
    },
    {
        path: '/siForgotPassword',
        name: 'siForgotPassword',
        exact: true,
        component: () => import('./components/simodule/ForgotPassword.vue')
    },
    {
        path: '/siForgotPasswordSubmission',
        name: 'siForgotPasswordSubmission',
        exact: true,
        component: () => import('./components/simodule/ForgotPasswordSubmission.vue')
    },
    {
        path: '/siHome',
        name: 'siHome',
        exact: true,
        component: () => import('./components/simodule/Home.vue')
    },
    {
        path: '/siSupport',
        name: 'siSupport',
        exact: true,
        component: () => import('./components/simodule/Support.vue')
    },
    {
        path: '/siCourse',
        name: 'siCourse',
        exact: true,
        component: () => import('./components/simodule/Course.vue')
    },
    {
        path: '/siSetGoals',
        name: 'siSetGoals',
        exact: true,
        component: () => import('./components/simodule/SetGoals.vue')
    },
    {
        path: '/siWatchlistAdd',
        name: 'siWatchlistAdd',
        exact: true,
        component: () => import('./components/simodule/WatchlistAdd.vue')
    },
    {
        path: '/siWatchlistRemove',
        name: 'siWatchlistRemove',
        exact: true,
        component: () => import('./components/simodule/WatchlistRemove.vue')
    },
    {
        path: '/siWatchlist',
        name: 'siWatchlist',
        exact: true,
        component: () => import('./components/simodule/Watchlist.vue')
    },
    {
        path: '/siAlerts',
        name: 'siAlerts',
        exact: true,
        component: () => import('./components/simodule/Alerts.vue')
    },
    {
        path: '/siPortfolioSummary',
        name: 'siPortfolioSummary',
        exact: true,
        component: () => import('./components/simodule/PortfolioSummary.vue')
    },
    {
        path: '/siCountryPortfolio',
        name: 'siCountryPortfolio',
        exact: true,
        component: () => import('./components/simodule/CountryPortfolio.vue')
    },
    {
        path: '/siTrackAddStock',
        name: 'siTrackAddStock',
        exact: true,
        component: () => import('./components/simodule/TrackAddStock.vue')
    },
    {
        path: '/siTrackAddOtherIncome',
        name: 'siTrackAddOtherIncome',
        exact: true,
        component: () => import('./components/simodule/TrackAddOtherIncome.vue')
    },
    {
        path: '/siAchievingGoals',
        name: 'siAchievingGoals',
        exact: true,
        component: () => import('./components/simodule/AchievingGoals.vue')
    },
    {
        path: '/siFeeTable',
        name: 'siFeeTable',
        exact: true,
        component: () => import('./components/simodule/FeeTable.vue')
    },
    {
        path: '/siConfigureSimulator',
        name: 'siConfigureSimulator',
        exact: true,
        component: () => import('./components/simodule/ConfigureSimulator.vue')
    },
    {
        path: '/siPortfolioSimulator',
        name: 'siPortfolioSimulator',
        exact: true,
        component: () => import('./components/simodule/PortfolioSimulator.vue')
    },
    {
        path: '/siAchieveAddStock',
        name: 'siAchieveAddStock',
        exact: true,
        component: () => import('./components/simodule/AchieveAddStock.vue')
    },
    {
        path: '/siAchieveAddOtherIncome',
        name: 'siAchieveAddOtherIncome',
        exact: true,
        component: () => import('./components/simodule/AchieveAddOtherIncome.vue')
    },
    {
        path: '/siMockPortfolio',
        name: 'siMockPortfolio',
        exact: true,
        component: () => import('./components/simodule/MockPortfolio.vue')
    },
    {
        path: '/siBasicSearch',
        name: 'siBasicSearch',
        exact: true,
        component: () => import('./components/simodule/BasicSearch.vue')
    },
    {
        path: '/siAdvancedSearch',
        name: 'siAdvancedSearch',
        exact: true,
        component: () => import('./components/simodule/AdvancedSearch.vue')
    },
    {
        path: '/siCompareStocks',
        name: 'siCompareStocks',
        exact: true,
        component: () => import('./components/simodule/CompareStocks.vue')
    },
    {
        path: '/siNewCustomFilter',
        name: 'siNewCustomFilter',
        exact: true,
        component: () => import('./components/simodule/NewCustomFilter.vue')
    },
    {
        path: '/siCustomFilters',
        name: 'siCustomFilters',
        exact: true,
        component: () => import('./components/simodule/CustomFilters.vue')
    },
    {
        path: '/siUserSettings',
        name: 'siUserSettings',
        exact: true,
        component: () => import('./components/simodule/UserSettings.vue')
    },
    {
        path: '/siEmailLists',
        name: 'siEmailLists',
        exact: true,
        component: () => import('./components/simodule/EmailLists.vue')
    },
    {
        path: '/siPassword',
        name: 'siPassword',
        exact: true,
        component: () => import('./components/simodule/Password.vue')
    },
    {
        path: '/siSubscription',
        name: 'siSubscription',
        exact: true,
        component: () => import('./components/simodule/Subscription.vue')
    },
    {
        path: '/siCancellation',
        name: 'siCancellation',
        exact: true,
        component: () => import('./components/simodule/Cancellation.vue')
    },
    {
        path: '/siHelp',
        name: 'siHelp',
        exact: true,
        component: () => import('./components/simodule/Help.vue')
    },
    {
        path: '/siColumnDefinitions',
        name: 'siColumnDefinitions',
        exact: true,
        component: () => import('./components/simodule/ColumnDefinitions.vue')
    },
    {
        path: '/siGlossary',
        name: 'siGlossary',
        exact: true,
        component: () => import('./components/simodule/Glossary.vue')
    },
    {
        path: '/siPlan',
        name: 'siPlan',
        exact: true,
        component: () => import('./components/simodule/Plan.vue')
    },
    {
        path: '/siTrack',
        name: 'siTrack',
        exact: true,
        component: () => import('./components/simodule/Track.vue')
    },
    {
        path: '/siPortfolioSummary',
        name: 'siPortfolioSummary',
        exact: true,
        component: () => import('./components/simodule/PortfolioSummary.vue')
    },
    {
        path: '/siCountryPortfolio',
        name: 'siCountryPortfolio',
        exact: true,
        component: () => import('./components/simodule/CountryPortfolio.vue')
    },
    {
        path: '/siTrackAddStock',
        name: 'siTrackAddStock',
        exact: true,
        component: () => import('./components/simodule/TrackAddStock.vue')
    },
    {
        path: '/siTrackAddOtherIncome',
        name: 'siTrackAddOtherIncome',
        exact: true,
        component: () => import('./components/simodule/TrackAddOtherIncome.vue')
    },
    {
        path: '/siAchievingGoals',
        name: 'siAchievingGoals',
        exact: true,
        component: () => import('./components/simodule/AchievingGoals.vue')
    },
    {
        path: '/siFeeTable',
        name: 'siFeeTable',
        exact: true,
        component: () => import('./components/simodule/FeeTable.vue')
    },
    {
        path: '/siConfigureSimulator',
        name: 'siConfigureSimulator',
        exact: true,
        component: () => import('./components/simodule/ConfigureSimulator.vue')
    },
    {
        path: '/siPortfolioSimulator',
        name: 'siPortfolioSimulator',
        exact: true,
        component: () => import('./components/simodule/PortfolioSimulator.vue')
    },
    {
        path: '/siAchieveAddStock',
        name: 'siAchieveAddStock',
        exact: true,
        component: () => import('./components/simodule/AchieveAddStock.vue')
    },
    {
        path: '/siAchieveAddOtherIncome',
        name: 'siAchieveAddOtherIncome',
        exact: true,
        component: () => import('./components/simodule/AchieveAddOtherIncome.vue')
    },
    {
        path: '/siMockPortfolio',
        name: 'siMockPortfolio',
        exact: true,
        component: () => import('./components/simodule/MockPortfolio.vue')
    },
    {
        path: '/siBasicSearch',
        name: 'siBasicSearch',
        exact: true,
        component: () => import('./components/simodule/BasicSearch.vue')
    },
    {
        path: '/siAdvancedSearch',
        name: 'siAdvancedSearch',
        exact: true,
        component: () => import('./components/simodule/AdvancedSearch.vue')
    },
    {
        path: '/siCompareStocks',
        name: 'siCompareStocks',
        exact: true,
        component: () => import('./components/simodule/CompareStocks.vue')
    },
    {
        path: '/siNewCustomFilter',
        name: 'siNewCustomFilter',
        exact: true,
        component: () => import('./components/simodule/NewCustomFilter.vue')
    },
    {
        path: '/siCustomFilters',
        name: 'siCustomFilters',
        exact: true,
        component: () => import('./components/simodule/CustomFilters.vue')
    },


    {
        path: '/userOverview',
        name: 'userOverview',
        exact: true,
        component: () => import('./components/usermodule/Overview.vue')
    },
    {
        path: '/application5',
        name: 'application5',
        exact: true,
        component: () => import('./components/applications/Application5.vue')
    },
    {
        path: '/application11',
        name: 'application11',
        exact: true,
        component: () => import('./components/applications/Application11.vue')
    },
    // {
    //     path: '/form',
    //     name: 'Form',
    //     component: () => import('./components/common/Form.vue.orig'),
    // },
    {
        path: '/formSuccessful',
        name: 'FormSuccessful',
        component: () => import('./components/common/FormSuccessful.vue'),
    },
    {
        path: '/formError',
        name: 'FormError',
        component: () => import('./components/common/FormError.vue'),
    },
    {
        path: '/booking',
        name: 'Booking',
        component: () => import('./components/common/Booking.vue'),
    },
    {
        path: '/bookingSuccessful',
        name: 'BookingSuccessful',
        component: () => import('./components/common/BookingSuccessful.vue'),
    },
    {
        path: '/bookingError',
        name: 'BookingError',
        component: () => import('./components/common/BookingError.vue'),
    },
    {
        path: '/sa/clientintake',
        name: 'ClientIntake',
        component: () => import('./components/common/ClientIntake.vue'),
    },
    {
        path: '/sa/clientintakecouples',
        name: 'ClientIntakeCouples',
        component: () => import('./components/common/ClientIntakeCouples.vue'),
    },
    {
        path: '/clientintakeSuccessful',
        name: 'ClientIntakeSuccessful',
        component: () => import('./components/common/ClientIntakeSuccessful.vue'),
    },
    {
        path: '/clientintakeError',
        name: 'ClientIntakeError',
        component: () => import('./components/common/ClientIntakeError.vue'),
    },
    {
        path: '/digitalform',
        name: 'DigitalForm',
        component: () => import('./components/common/DigitalForm.vue'),
    },
    {
        path: '/digitalbooking',
        name: 'DigitalBooking',
        component: () => import('./components/common/DigitalBooking.vue'),
    },
    {
        path: '/appointmentConfirmation',
        name: 'AppointmentConfirmation',
        component: () => import('./components/common/AppointmentConfirmation.vue'),
    },
    {
        path: '/isogrowLogin',
        name: 'isogrowLogin',
        exact: true,
        component: () => import('./components/isogrow/Login.vue')
    },
    {
        path: '/isogrowOverview',
        name: 'isogrowOverview',
        exact: true,
        component: () => import('./components/isogrow/Overview.vue')
    },
    {
        path: '/isogrowPortfolio',
        name: 'isogrowPortfolio',
        exact: true,
        component: () => import('./components/isogrow/Portfolio.vue')
    },
    {
        path: '/isogrowNetWorth',
        name: 'isogrowNetWorth',
        exact: true,
        component: () => import('./components/isogrow/NetWorth.vue')
    },
    {
        path: '/isogrowIncome',
        name: 'isogrowIncome',
        exact: true,
        component: () => import('./components/isogrow/Income.vue')
    },
    {
        path: '/isogrowInvestments',
        name: 'isogrowInvestments',
        exact: true,
        component: () => import('./components/isogrow/Investments.vue')
    },
    {
        path: '/isogrowRisk',
        name: 'isogrowRisk',
        exact: true,
        component: () => import('./components/isogrow/Risk.vue')
    },
    {
        path: '/isogrowHealth',
        name: 'isogrowHealth',
        exact: true,
        component: () => import('./components/isogrow/Health.vue')
    },
    {
        path: '/isogrowTax',
        name: 'isogrowTax',
        exact: true,
        component: () => import('./components/isogrow/Tax.vue')
    },
    {
        path: '/isogrowEstatePlanning',
        name: 'isogrowEstatePlanning',
        exact: true,
        component: () => import('./components/isogrow/EstatePlanning.vue')
    },
    {
        path: '/isogrowGoals',
        name: 'isogrowGoals',
        exact: true,
        component: () => import('./components/isogrow/Goals.vue')
    },
    {
        path: '/isogrowTools',
        name: 'isogrowTools',
        exact: true,
        component: () => import('./components/isogrow/Tools.vue')
    },
    {
        path: '/isogrowProfile',
        name: 'isogrowProfile',
        exact: true,
        component: () => import('./components/isogrow/Profile.vue')
    },
    {
        path: '/isogrowConfiguration',
        name: 'isogrowConfiguration',
        exact: true,
        component: () => import('./components/isogrow/Configuration.vue')
    },
    {
        path: '/isogrowEducation',
        name: 'isogrowEducation',
        exact: true,
        component: () => import('./components/isogrow/Education.vue')
    },
    {
        path: '/isogrowTasks',
        name: 'isogrowTasks',
        exact: true,
        component: () => import('./components/isogrow/Tasks.vue')
    },
    {
        path: '/isogrowDocuments',
        name: 'isogrowDocuments',
        exact: true,
        component: () => import('./components/isogrow/Documents.vue')
    },
    {
        path: '/:pathMatch(.*)*', // This will catch all undefined routes
        redirect: '/error', // Redirect to the error component
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)
            return savedPosition
        else
            return {left: 0, top: 0};
    }
});

export default router;


router.beforeEach((to, from, next) => {
    const userStore = useUserStore();

    // Use the new getter for a complete check
    const isAuthenticated = userStore.isTokenValid;

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !isAuthenticated) {
        next({name: 'Login'});
    } else {
        next();
    }
});
